
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import useLocale from 'next-translate/useTranslation';
import React from 'react';
import { Image as ImageType } from 'types';
import { getPublicImagesPaginated } from '@/data/images';
// Above-the-fold hero is imported statically.
import ImageHero from '@/components/images/landing/ImageHero';
import Footer from '@/components/layout/Footer';
import Seo from '@/components/Seo';
// Below-the-fold sections are code-split.
const ImageShowcaseRows = dynamic(() => import('@/components/images/landing/ImageShowcaseRows'));
const ImageToolsWall = dynamic(() => import('@/components/images/landing/ImageToolsWall'));
const ImageModelsBand = dynamic(() => import('@/components/images/landing/ImageModelsBand'));
const StylesWall = dynamic(() => import('@/components/images/landing/StylesWall'));
const DarkTemplatesGrid = dynamic(() => import('@/components/media/DarkTemplatesGrid'));
const UserImages = dynamic(() => import('@/components/images/UserImages'));
const ImagesFaq = dynamic(() => import('@/components/ImagesFAQ'));
const FeaturedLogos = dynamic(() => import('@/components/FeaturedLogos'));
const Testimonials = dynamic(() => import('@/components/Testimonials'), {
    ssr: false,
});
const CallToAction = dynamic(() => import('@/components/CallToAction'));
interface ImageProps {
    images: ImageType[];
}
const ImageGenerator = ({ images }: ImageProps) => {
    const { t, lang } = useLocale('ai-image-generator');
    return (<main className='relative bg-[#07070C]'>
      <Seo templateTitle={t('Best AI Image & Art Generator | Online Text to Image App')} description={t('Experience the power of our state-of-the-art AI technology. Generate high-quality, customizable, and versatile images with just a few clicks.')} image='https://media.easy-peasy.ai/landing/image/og-image.jpg'/>

      <ImageHero />
      <ImageShowcaseRows />
      <ImageToolsWall />
      <ImageModelsBand />
      <StylesWall />

      {/* User Generated Images Showcase */}
      {lang === 'en' && (<section className='dark relative border-y border-white/[0.06] bg-white/[0.02] py-20 text-slate-200 lg:py-28'>
          <UserImages initialImages={images} useLoadMore={true} currentImage='0'/>
        </section>)}

      <DarkTemplatesGrid kind='image' basePath='/ai-image-generator/templates' heading={t('Start from a proven template')} subheading={t('Real prompts behind real results — open one and make it yours.')} showAllLabel={t('Show all templates')}/>

      <div className='dark'>
        {lang === 'en' && <ImagesFaq />}
        <FeaturedLogos forceDark={true}/>
        <Testimonials forceDark={true}/>
        <CallToAction preset='ai-images'/>
        <Footer variant='dark'/>
      </div>
    </main>);
};
export default ImageGenerator;
const getStaticProps = async () => {
    const images = await getPublicImagesPaginated(1, 24);
    return {
        props: { images },
    };
};

    async function __Next_Translate__getStaticProps__1a12e86ed2b__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-image-generator/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a12e86ed2b__ as getStaticProps }
  